<template>
  <div class="phone">
    <div class="itemBox" @click="openMp">
      <div class="left">
        <span class="t1">修改手机号</span>
        <span class="t2" v-if="!tel">当前手机号未授权</span>
        <span class="t2" v-else>{{ tel }}</span>
      </div>
      <div class="getphone" v-if="!tel">授权</div>
      <img src="../../assets/my/next2.png" v-else  />
    </div>
    <div class="itemBox" @click="toPwd">
      <div class="left">
        <span class="t1">支付密码</span>
        <span class="t2">账户余额支付等服务时，用户验证</span>
      </div>
      <img src="../../assets/my/next2.png"  />
    </div>
  

    <van-dialog v-model="show" title="长按识别二维码跳转小程序" show-cancel-button>
      <img class="qrImg" :src="Qrurl" style="margin:0 auto;display:block;" />
    </van-dialog>
  </div>
</template>
<script>
import qrCode from "qrcode";

export default {
  data() {
    return {
      Qrurl: "",
      tel: "",
      show: false
    };
  },
  created() {
    // this.tel = this.$route.query.tel;
    this.getMyInfo()
    qrCode
      .toDataURL("https://open.weixin.qq.com/sns/getexpappinfo?appid=wx0c783cd36e99604a&path=pages%2Fhome%2Findex%2Findex.html#wechat-redirect")
      .then(res => {
        this.Qrurl = res;
      })
      .catch(err => {
        console.error(err);
      });
  },
  methods: {
    openMp() {
      if (!this.tel) {
        this.show = true;
        return 
      }
      this.$router.push({name:'revisePhone'})

    },

    getMyInfo(){
      this.$http({
        url:'my'
      }).then(res=>{
        console.log(res.data)
        this.tel = res.data.tel
      })
    },
    toPwd() {
      if (this.tel) {
        this.$router.push({ name: "revisePassword" });
      } else {
        // this.$toast("请点击授权跳转至小程序获取您的手机号");
        this.show = true

      }
    }
  }
};
</script>



<style lang="less" scoped>
.phone {
  .itemBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 135px;
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    margin-bottom: 2px;
    background-color: #fff;
    .left {
      display: flex;
      flex-direction: column;
      .t1 {
        font-size: 28px;
        color: #333;
      }
      .t2 {
        font-size: 24px;
        color: #999;
      }
    }
    .getphone {
      width: 75px;
      height: 42px;
      border: 1px solid #e42129;
      color: #e42129;
      font-size: 24px;
      line-height: 42px;
      text-align: center;
    }
    img {
      width: 20px;
    }
  }
}
</style>
